import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5fbb60e4&lang=less&scoped=true"

import exportComponent from "D:\\project\\zillion\\developCompany\\pzh_develop_website发展集团官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fbb60e4"]])

export default __exports__